(function(){
  'use strict';
  // Technical drilling services stay cart add-ons, never saved-list products.
  function isService(item) {
    if (!item) return false;
    var id = String(item.productId || item.empi || '').split('/').pop();
    if (['10076688515351', '10539203494167', '10539203592471'].indexOf(id) !== -1) return true;
    var match = String(item.du || item.url || '').match(/\/products\/([^/?#]+)/);
    var handle = String(item.handle || (match && match[1]) || '').toLowerCase();
    return /^(?:single-handle-configuration|4-in-centerset-faucet-configuration(?:-double-sink)?)$/.test(handle)
      || /faucet-(?:configuration|modification)/.test(handle)
      || item.productType === 'countertop_service';
  }

  function handle(item){
    var match=String(item && item.du || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }
  function variant(item){
    if(item && item.epi) return String(item.epi).split('/').pop();
    try{return new URL(item.du,location.origin).searchParams.get('variant') || '';}catch(_){return '';}
  }
  function key(item){return handle(item)+':'+variant(item);}
  function items(payload){
    var all=[];var seen=new Set();
    (Array.isArray(payload)?payload:[]).forEach(function(entry){
      if(!entry)return;
      all=all.concat(Array.isArray(entry.listcontents)?entry.listcontents:[entry]);
    });
    return all.filter(function(item){
      if(!handle(item) || isService(item))return false;
      var id=key(item);if(seen.has(id))return false;seen.add(id);return true;
    });
  }
  window.WillowWishlistData={handle:handle,variant:variant,key:key,items:items};
})();
